import React from 'react'
import styled from 'styled-components'
import Link from '../Link'
import styles from '../../constants/styles'
import OptimizedImage from '../shared/OptimizedImage'

const TopNav = () => (
  <Container>
    <Link href="/" style={{ width: '20%', height: '100%' }}>
      <Logo
        src={'../../static/abillion-logo-all-white.svg'}
        alt="abillion logo"
        title="abillion logo"
      />
    </Link>
  </Container>
)

export default TopNav

const Container = styled.nav`
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  top: 0;
  position: absolute;
  z-index: 100;
  padding: ${styles.padding.medium} ${styles.padding.huge};
  @media (max-width: 600px) {
    padding: ${styles.padding.medium} ${styles.padding.large};
  }
`

const Logo = styled(OptimizedImage)`
  height: 100%;
  object-fit: cover;
`
